module.exports = __webpack_public_path__ + "front/img/home-kv.9ffc7d66.png";